import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { IAppDispatch, IStore } from '.';

export const useAppDispatch: IAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IStore> = useSelector;
